import awaitUserLogin from '@components/login/awaitUserLogin';
import React from 'react';

import { addSavedProduct, removeSavedProduct } from '../savedItems';

const onSavedClickProduct = async (userContext: UserContext, saved: boolean, product: guesthouse.ProductLite, e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  if (typeof e?.stopPropagation === 'function') {
    e.stopPropagation();
  }
  
  if (userContext.user) {
    if (saved) {
      removeSavedProduct(userContext.user.uid, product);
    } else {
      addSavedProduct(userContext.user.uid, product);
    }
  } else {
    await awaitUserLogin(userContext)
      .then((user) => {
        addSavedProduct(user.uid, product);
      });
  }
};

export default onSavedClickProduct;
